var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloudMonitoring(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 13.5001H13.4925C13.3309 13.4984 13.1741 13.4445 13.0455 13.3465C12.917 13.2485 12.8236 13.1115 12.7792 12.9561L11.4342 8.25008H8.25V6.75008H12C12.163 6.75008 12.3215 6.80316 12.4516 6.9013C12.5817 6.99944 12.6763 7.13728 12.7211 7.29398L13.5268 10.1132L15.7834 2.77943C15.832 2.62706 15.9274 2.49389 16.0561 2.39886C16.1847 2.30383 16.3401 2.25177 16.5 2.25008C16.658 2.24774 16.8125 2.29637 16.9406 2.38874C17.0688 2.48112 17.1638 2.61233 17.2115 2.76293L18.5405 6.75008H22.5V8.25008H18C17.8426 8.25008 17.6892 8.20055 17.5615 8.10851C17.4338 8.01646 17.3383 7.88657 17.2885 7.73723L16.5286 5.45723L14.2167 12.9707C14.1695 13.124 14.0745 13.2581 13.9455 13.3534C13.8165 13.4486 13.6604 13.5001 13.5 13.5001Z",
    fill: "#67C2E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12V16.5H3V4.5H8.25V3H3C2.60218 3 2.22064 3.15804 1.93934 3.43934C1.65804 3.72064 1.5 4.10218 1.5 4.5V16.5C1.5 16.8978 1.65804 17.2794 1.93934 17.5607C2.22064 17.842 2.60218 18 3 18H9V21H6V22.5H18V21H15V18H21C21.3978 18 21.7794 17.842 22.0607 17.5607C22.342 17.2794 22.5 16.8978 22.5 16.5V12H21ZM13.5 21H10.5V18H13.5V21Z",
    fill: "#265EA7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudMonitoring);
export default __webpack_public_path__ + "static/media/CloudMonitoring.8dc161dc10624f1d2a96e151874d86c2.svg";
export { ForwardRef as ReactComponent };